const evaluateGroupMessage = ({ args }) => {
  const stepIds = args?.inputStepIds || [];

  if (stepIds.length < 1) {
    return 'Group data sources';
  }

  return `Group ${stepIds.length} data source${stepIds.length === 1 ? '' : 's'}`;
};

export default evaluateGroupMessage;
